import { useState } from 'react';

export default function VideoModal({ videoId, exerciseName, dayColor, onClose }) {
  const youtubeUrl = `https://www.youtube.com/watch?v=${videoId}`;
  const thumbHQ    = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  const thumbMR    = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  const [thumb, setThumb] = useState(thumbMR);

  const openVideo = () => {
    window.open(youtubeUrl, "_blank", "noopener,noreferrer");
  };

  const stop = e => e.stopPropagation();

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 200,
        background: "rgba(0,0,0,0.88)",
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        padding: "0 16px env(safe-area-inset-bottom)",
      }}
    >
      <div onClick={stop} style={{ width: "100%", maxWidth: 520, display: "flex", flexDirection: "column", gap: 14 }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#fff" }}>{exerciseName}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>Form Guide · YouTube</div>
          </div>
          <button onClick={onClose} style={{
            width: 36, height: 36, borderRadius: "50%", border: "none", cursor: "pointer",
            background: "rgba(255,255,255,0.12)", color: "#fff", fontSize: 20, fontWeight: 400,
            display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "inherit",
          }}>×</button>
        </div>

        {/* Thumbnail + tap-to-play */}
        <button
          onClick={openVideo}
          style={{
            position: "relative", width: "100%", paddingBottom: "56.25%",
            borderRadius: 16, overflow: "hidden", border: "none", cursor: "pointer", padding: 0,
            background: "#000",
          }}
        >
          <img
            src={thumb}
            onError={() => setThumb(thumbHQ)}
            alt={exerciseName}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
          />
          {/* Dark overlay */}
          <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.28)" }}/>
          {/* Play button */}
          <div style={{
            position: "absolute", inset: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <div style={{
              width: 68, height: 68, borderRadius: "50%",
              background: dayColor || "#4f8fff",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: `0 0 0 6px ${(dayColor || "#4f8fff")}33, 0 8px 32px rgba(0,0,0,0.5)`,
            }}>
              <svg viewBox="0 0 24 24" width="30" height="30" fill="white" style={{ marginLeft: 3 }}>
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
          </div>
        </button>

        {/* Open in YouTube button */}
        <button
          onClick={openVideo}
          style={{
            width: "100%", padding: "14px 20px", borderRadius: 14, border: "none", cursor: "pointer",
            background: "#FF0000", fontFamily: "inherit", display: "flex", alignItems: "center",
            justifyContent: "center", gap: 10,
          }}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="white">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>Watch on YouTube</span>
        </button>

        <div style={{ textAlign: "center", fontSize: 12, color: "rgba(255,255,255,0.3)" }}>
          Tap outside to close
        </div>
      </div>
    </div>
  );
}
